import getSliceName from '@om-fe/core/utils/get-slice-name';
import { LIVE_SIDEBAR_COMPONENT } from './live-event-sidebar.constants';
import { getLiveMatchListSliceName } from '../../../match-list/containers/live-match-list/live-match-list.utils';
import { SLICE_MATCH_DETAILS } from '@om-fe/core/components/match-details/match-details.store';
import { liveSidebarNavSlice } from '../sports-nav/live-event-sidebar-sports-nav.constants';

export function getLiveSidebarComponentSliceName(component: LIVE_SIDEBAR_COMPONENT, instanceId: string): string {
    switch (component) {
        case LIVE_SIDEBAR_COMPONENT.NAV:
            return getSliceName(liveSidebarNavSlice, instanceId);
        case LIVE_SIDEBAR_COMPONENT.LIST:
            return getLiveMatchListSliceName(instanceId);
        case LIVE_SIDEBAR_COMPONENT.MATCH:
            return SLICE_MATCH_DETAILS;
        default:
            return '';
    }
}
